import type { ExerciseTemplate } from '@yuan-math/exercises';
import { ARITHMETIC_TEMPLATES } from './arithmetic.ts';
import { GRADE_THREE_TEMPLATES } from './grade-three.ts';
import { GRADE_FOUR_TEMPLATES } from './grade-four.ts';
import { GRADE_FIVE_TEMPLATES } from './grade-five.ts';
import { FRACTION_TEMPLATES } from './fractions.ts';
import { APPLIED_TEMPLATES } from './applied.ts';
import { MIDDLE_TEMPLATES } from './middle.ts';
import { RATIO_TEMPLATES } from './ratios.ts';
import { GEOMETRY_MIDDLE_TEMPLATES } from './geometry-middle.ts';
import { RATIONAL_NUMBER_TEMPLATES } from './rational-numbers.ts';
import { PROPORTION_TEMPLATES } from './proportion.ts';
import { LINEAR_EXPRESSION_TEMPLATES } from './linear-expressions.ts';
import { EQUATION_TEMPLATES } from './equations.ts';
import { GEOMETRY_UPPER_TEMPLATES } from './geometry-upper.ts';
import { PROBABILITY_TEMPLATES } from './probability.ts';
import { SAMPLING_TEMPLATES } from './sampling.ts';
import { EXPONENT_RULE_TEMPLATES } from './exponent-rules.ts';
import { ROOT_TEMPLATES } from './roots.ts';
import { FUNCTION_TEMPLATES } from './functions.ts';
import { GEOMETRY_EIGHT_TEMPLATES } from './geometry-eight.ts';
import { SCATTER_TEMPLATES } from './scatter.ts';
import { ALGEBRA_FOUNDATION_TEMPLATES } from './algebra-foundations.ts';
import { ALGEBRA_ONE_LINEAR_TEMPLATES } from './algebra-one-linear.ts';
import { POLYNOMIAL_TEMPLATES } from './polynomials.ts';
import { QUADRATIC_TEMPLATES } from './quadratics.ts';
import { ALGEBRA_ONE_TEMPLATES } from './algebra-one.ts';
import { GEOMETRY_PROOF_TEMPLATES } from './geometry-proof.ts';
import { GEOMETRY_HS_TEMPLATES } from './geometry-hs.ts';
import { ALGEBRA_TWO_TEMPLATES } from './algebra-two.ts';
import { FUNCTIONS_HS_TEMPLATES } from './functions-hs.ts';
import { PRECALCULUS_TEMPLATES } from './precalculus.ts';
import { COUNTING_TEMPLATES } from './counting.ts';
import { GRADE_ELEVEN_TEMPLATES } from './grade-eleven.ts';
import { CALCULUS_TEMPLATES } from './calculus.ts';
import { INTEGRATION_TECHNIQUE_TEMPLATES } from './integration-techniques.ts';
import { INTEGRAL_APPLICATION_TEMPLATES } from './integral-applications.ts';
import { SERIES_TEMPLATES } from './series.ts';
import { PARAMETRIC_POLAR_TEMPLATES } from './parametric-polar.ts';
import { LINEAR_ALGEBRA_TEMPLATES } from './linear-algebra.ts';
import { PROBABILITY_UNIVERSITY_TEMPLATES } from './probability-university.ts';
import { RANDOM_VARIABLE_TEMPLATES } from './random-variables.ts';
import { DISTRIBUTION_TEMPLATES } from './distributions.ts';
import { INFERENCE_TEMPLATES } from './inference.ts';

export const EXERCISE_TEMPLATES: ExerciseTemplate[] = [
  ...ARITHMETIC_TEMPLATES,
  ...GRADE_THREE_TEMPLATES,
  ...GRADE_FOUR_TEMPLATES,
  ...GRADE_FIVE_TEMPLATES,
  ...FRACTION_TEMPLATES,
  ...APPLIED_TEMPLATES,
  ...MIDDLE_TEMPLATES,
  ...RATIO_TEMPLATES,
  ...GEOMETRY_MIDDLE_TEMPLATES,
  ...RATIONAL_NUMBER_TEMPLATES,
  ...PROPORTION_TEMPLATES,
  ...LINEAR_EXPRESSION_TEMPLATES,
  ...EQUATION_TEMPLATES,
  ...GEOMETRY_UPPER_TEMPLATES,
  ...PROBABILITY_TEMPLATES,
  ...SAMPLING_TEMPLATES,
  ...EXPONENT_RULE_TEMPLATES,
  ...ROOT_TEMPLATES,
  ...FUNCTION_TEMPLATES,
  ...GEOMETRY_EIGHT_TEMPLATES,
  ...SCATTER_TEMPLATES,
  ...ALGEBRA_ONE_LINEAR_TEMPLATES,
  ...ALGEBRA_FOUNDATION_TEMPLATES,
  ...POLYNOMIAL_TEMPLATES,
  ...QUADRATIC_TEMPLATES,
  ...ALGEBRA_ONE_TEMPLATES,
  ...GEOMETRY_PROOF_TEMPLATES,
  ...GEOMETRY_HS_TEMPLATES,
  ...ALGEBRA_TWO_TEMPLATES,
  ...FUNCTIONS_HS_TEMPLATES,
  ...PRECALCULUS_TEMPLATES,
  ...COUNTING_TEMPLATES,
  ...GRADE_ELEVEN_TEMPLATES,
  ...CALCULUS_TEMPLATES,
  ...INTEGRATION_TECHNIQUE_TEMPLATES,
  ...INTEGRAL_APPLICATION_TEMPLATES,
  ...SERIES_TEMPLATES,
  ...PARAMETRIC_POLAR_TEMPLATES,
  ...LINEAR_ALGEBRA_TEMPLATES,
  ...PROBABILITY_UNIVERSITY_TEMPLATES,
  ...RANDOM_VARIABLE_TEMPLATES,
  ...DISTRIBUTION_TEMPLATES,
  ...INFERENCE_TEMPLATES,
];

export {
  ARITHMETIC_TEMPLATES,
  GRADE_THREE_TEMPLATES,
  GRADE_FOUR_TEMPLATES,
  GRADE_FIVE_TEMPLATES,
  FRACTION_TEMPLATES,
  APPLIED_TEMPLATES,
  MIDDLE_TEMPLATES,
  RATIO_TEMPLATES,
  GEOMETRY_MIDDLE_TEMPLATES,
  RATIONAL_NUMBER_TEMPLATES,
  PROPORTION_TEMPLATES,
  LINEAR_EXPRESSION_TEMPLATES,
  EQUATION_TEMPLATES,
  GEOMETRY_UPPER_TEMPLATES,
  PROBABILITY_TEMPLATES,
  SAMPLING_TEMPLATES,
  EXPONENT_RULE_TEMPLATES,
  ROOT_TEMPLATES,
  FUNCTION_TEMPLATES,
  GEOMETRY_EIGHT_TEMPLATES,
  SCATTER_TEMPLATES,
  ALGEBRA_ONE_LINEAR_TEMPLATES,
  ALGEBRA_FOUNDATION_TEMPLATES,
  POLYNOMIAL_TEMPLATES,
  QUADRATIC_TEMPLATES,
  ALGEBRA_ONE_TEMPLATES,
  GEOMETRY_PROOF_TEMPLATES,
  GEOMETRY_HS_TEMPLATES,
  ALGEBRA_TWO_TEMPLATES,
  FUNCTIONS_HS_TEMPLATES,
  PRECALCULUS_TEMPLATES,
  COUNTING_TEMPLATES,
  GRADE_ELEVEN_TEMPLATES,
  CALCULUS_TEMPLATES,
  INTEGRATION_TECHNIQUE_TEMPLATES,
  INTEGRAL_APPLICATION_TEMPLATES,
  SERIES_TEMPLATES,
  PARAMETRIC_POLAR_TEMPLATES,
  LINEAR_ALGEBRA_TEMPLATES,
  PROBABILITY_UNIVERSITY_TEMPLATES,
  RANDOM_VARIABLE_TEMPLATES,
  DISTRIBUTION_TEMPLATES,
  INFERENCE_TEMPLATES,
};
